<template>
    <div v-if="room && ownerSubscribed">
        <header class="header">
            <div class="container">
                <div class="row align-items--center">
                    <div class="col-2">
                    </div>

                    <div class="col-8">
                        <h1 class="header__title">Scholar test</h1>
                    </div>

                    <div class="col-2 text--right">
                        <button type="button" @click="confirmClose" class="btn btn--icon btn--white">
                            <i class="material-icons">close</i>
                        </button>
                    </div>
                </div>
            </div>
        </header>

        <section class="container animated fadeIn">
            <div class="intro-content pt--40 pb--20">
                <div class="profile profile--vertical profile--lg mb--20">
                    <figure class="profile__avatar">
                        <span class="profile__avatar__img"><img src="/img/pictures/avatar-2.jpg" alt=""/></span>
                    </figure>

                    <div class="profile__text">
                        <div class="profile__name mb--0">{{ room.name }}</div>
                        <div class="c--primary"><strong>Level {{ room.level }} / {{ questionGroupName }}</strong></div>
                    </div>
                </div>
            </div>
        </section>

        <div class="pt--20 pb--20 mb--lg bg--layer-light text--center">
            <div class="container">
                <div class="row">
                    <div class="col-8 mx--auto">
                        <h4 class="text--xs text--uppercase opacity--md">Room code</h4>

                        <div class="h1 mb--0">
                            {{ roomURL() }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">

            <standings :table="table"></standings>

            <button type="button" :disabled="startInProgress" class="btn btn--block btn--purple mb--lg" @click="startGame()">Start test</button>

            <div class="panel bg--layer-dark mb--md">
                <table class="text--sm" v-if="members">
                    <tr v-for="member in members">
                        <td class="pl--0">
                            <div class="profile profile--inline profile--horizontal">
                                <figure class="profile__avatar">
                                    <span class="profile__avatar__img"><img src="/img/pictures/avatar-1.jpg"
                                                                            alt=""/></span>
                                </figure>

                                <div class="profile__text">
                                    <div class="profile__name">{{ member.nick }}</div>
                                </div>
                            </div>
                        </td>
                        <td class="pr--0 text--right">

                        </td>
                    </tr>
                </table>
            </div>

            <h2 class="h1 text--center">Matches</h2>
            <p class="text--center opacity--sm">Ready</p>
            <matches-table :matches="finishedMatches"></matches-table>
        </div>

        <modal ref="confirmCloseModal" show="false" type="error">
            <template v-slot:message>
                Are you sure? No way back... :)
            </template>

            <template v-slot:buttons>
                <button type="button" @click="closeGame" class="btn btn--block btn--primary">Yes</button>
                <button type="button" @click="hideConfirmAlert" class="btn btn--block btn--green">No</button>
            </template>
        </modal>
    </div>
</template>

<script>
    import Standings from "./partial/Standings";
    import MatchesTable from "./partial/MatchesTable";

    export default {
        components: {Standings, MatchesTable},

        props: ['table', 'matches'],

        data: function () {
            return {
                room: null,
                ownerSubscribed: false,
                members: null,
                startInProgress: false
            }
        },

        computed: {
            questionGroupName() {
                return get(this.room.questionGroup, 'name', 'All categories')
            }
        },

        methods: {
            confirmClose() {
                this.$refs.confirmCloseModal.open()
            },

            closeGame() {
                this.hideConfirmAlert()
                this.$router.push('/')
            },

            hideConfirmAlert() {
                this.$refs.confirmCloseModal.close()
            },

            roomURL() {
                let route = this.$router.resolve({
                    name: 'findScholarRoom',
                    params: { code: this.room.id },
                })

                return window.app_url + route.href
            },

            finishedMatches() {
                return this.matches.filter((item) => item.status === 'finished')
            },

            startGame() {

                if (this.startInProgress) {
                    return
                }

                this.startInProgress = true

                if (! this.members || this.members.length < 2) {
                    alert('There are not enough players to start a game. Please try again later.')
                    this.startInProgress = false
                    return
                }

                this.send({
                    event: "startScholar",
                    data: {
                        channel: 'scholar-' + this.room.id,
                    }
                });

                Quiz.$emit('scholar-game-started')
                this.startInProgress = false
            }
        },

        created() {
            Quiz.$on('scholar-room-created', (data) => {
                this.room = data
                this.subscribe('scholar-' + this.room.id, {
                    permission: 'access scholar mode',
                })
            })

            Quiz.$on('pusher_internal:subscription_succeeded', (message) => {
                if (message.channel === 'scholar-' + this.room.id) {
                    this.ownerSubscribed = true
                }
            })

            Quiz.$on('channelMembers', (message) => {
                if (message.data.channel === 'scholar-' + this.room.id) {
                    this.members = message.data.members
                }
            })
        },

        beforeDestroy() {
            if (this.room) {
                this.unsubscribe('scholar-' + this.room.id)
            }
            Quiz.$off('channelMembers')
            Quiz.$off('scholar-room-created')
            Quiz.$off('pusher_internal:subscription_succeeded')
        }
    }
</script>
